import { jsx as _jsx } from "react/jsx-runtime";
import { styled, useStyleConfig, vui } from '../core';
import { cs } from '../utils';
import { useTableContext } from './context';
export const TdBase = styled.tdBox `
  transition-duration: fast;
`;
/** Displays a cell inside Table row. */
export const Td = vui((props, ref) => {
    const { className, ...rest } = props;
    const styles = useStyleConfig('Table', useTableContext());
    return _jsx(TdBase, { className: cs('vui-td', className), px: 2, ref: ref, ...styles.td, ...rest });
});
Td.displayName = 'Td';
export default Td;
